import styled from 'styled-components'
import { Icon } from 'components/atoms'

export const ActiveItem = styled.div`
  width: 100%;
  height: 400px;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  background-image: url('${ (props) => props.content }');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 10px;
`

export const Slider = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 20px;
  overflow-y: hidden;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin-bottom: 30px;
  }
`

export const SliderContent = styled.div`
  display: flex;
  flex-grow: 1;
  overflow-x: scroll;
  overflow-y: hidden;
  height: 80px;
`

export const ItemList = styled.div`
  display: flex;
  height: 60px;
  width: 100%;
`

export const Item = styled.div`
  height: 60px;
  min-width: 80px;
  margin: 0 7.5px;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  background-image: url('${ (props) => props.content }');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
`

export const Arrow = styled.div`
  display: flex;
  min-width: 50px;
  justify-content: center;
  background: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
  cursor: pointer;
  align-items: center;
`

export const ArrowIcon = styled(Icon)``
